import { Flex, Stack } from "@mantine/core";
import { useEffect } from "react";

import { useSalesContext } from "../../../sales-context/SalesContext";
import { useVerificationFlowStore, useVerifiedCustomerStore } from "../../../stores";
import { usePushDiscoveryEngagementToTimeline } from "../hooks/usePushDiscoveryEngagementToTimeline";
import { CustomerOffers } from "./customer-offers/CustomerOffers";
import { CustomerProfile } from "./customer-profile/CustomerProfile";
import { CustomerVerification } from "./customer-verification/CustomerVerification";
import classes from "./CustomerPanel.module.css";

export function CustomerPanel() {
    const { sessionId, taskType, taskData, features } = useSalesContext();

    const isCustomerFlowComplete = useVerifiedCustomerStore(
        (state) => state.getVerifiedCustomer(sessionId).isCustomerVerificationComplete,
    );
    const { isPreviousSessionSummaryEnabled } = features;

    const stepHistory = useVerificationFlowStore((state) => state.getStepHistory(sessionId));

    // Owned here, not in CustomerOffers: this is a once-per-session push that must fire when
    // eligibility lands, and CustomerPanel is mounted for the whole session while CustomerOffers is
    // only rendered post-verification. The redesign's equivalent owner is Sidecar. See the hook.
    usePushDiscoveryEngagementToTimeline();

    // Sync verification completion from step history
    useEffect(() => {
        const isFlowComplete = stepHistory.at(stepHistory.length - 1) === "VerificationComplete";
        if (isFlowComplete !== isCustomerFlowComplete) {
            useVerifiedCustomerStore.getState().setIsCustomerVerificationComplete(sessionId, isFlowComplete);
        }
    }, [stepHistory, isCustomerFlowComplete, sessionId]);

    if (!taskType.isVoice && !taskType.isChat) {
        return undefined;
    }

    return (
        <Flex className={classes.customerPanel} data-testid="customer-panel">
            <Flex className={classes.responsivePanel}>
                <Flex className={classes.topSection}>
                    <CustomerProfile />
                </Flex>

                {!isCustomerFlowComplete ? (
                    <CustomerVerification
                        mdnFromTask={taskData.mdn ?? ""}
                        isPreviousSessionSummaryEnabled={isPreviousSessionSummaryEnabled}
                    />
                ) : (
                    <Stack mt={"sm"}>
                        <CustomerOffers />
                    </Stack>
                )}
            </Flex>
        </Flex>
    );
}
